import { useEffect, useState } from 'react'

import { useIGAO } from '../../context'
import { filterItemsByStatus, sortAction } from '../../utils'

import { Action } from './action'

export function Actions ({
  item,
  issue,
  shiftDown,
  handleKeyUp,
  handleKeyDown,
  handleInputSubmit,
  handleBatch,
  uid,
  setSelectedIssue,
  selected
}) {
  const { createAction, filters } = useIGAO()
  const [ editId, setEditId ] = useState(null)
  const [ canSave, setCanSave ] = useState(null)

  useEffect(() => {
    setCanSave(true)

    return () => {
      setCanSave(null)
    }
  }, [ setCanSave ])

  const sortedAction = sortAction(filterItemsByStatus(issue.actions, filters))

  const deleteAction = id => {
    setCanSave(true)
    createAction(item.id, issue.id, { id }, false)
  }

  return (
    <div data-cy='action-list'>
      {sortedAction?.map(act => (
        <Action
          key={`${act.id}+${JSON.stringify(act.details)}`}
          canSave={canSave}
          item={item}
          setCanSave={setCanSave}
          setEditId={setEditId}
          editId={editId}
          handleBatch={handleBatch}
          action={act}
          deleteAction={deleteAction}
          handleKeyUp={handleKeyUp}
          handleKeyDown={handleKeyDown}
          issue={issue}
          handleInputSubmit={handleInputSubmit}
          uid={uid}
          shiftDown={shiftDown}
          setSelectedIssue={setSelectedIssue}
          selected={selected}
        />
      ))}
    </div>
  )
}
